// https://gist.github.com/mathewbyrne/1280286
export default function slugify(
  text?: string | number | null,
  disallowNonWordChar = true,
): string {
  const base = text == null ? '' : String(text);
  let slugifyText = base.toLowerCase().replace(/\s+/g, '-'); // Replace spaces with -

  const hasNonWordChar = /[^\w\-]+/g.test(slugifyText);

  if (disallowNonWordChar) {
    slugifyText = slugifyText.replace(/[^\w\-]+/g, ''); // Remove all non-word chars
  }

  slugifyText = slugifyText
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text

  if (hasNonWordChar && base) {
    console.warn(
      `Slugify: The text "${base}" contains non-word characters. They have ${
        disallowNonWordChar ? '' : 'not'
      } been removed. Result: "${slugifyText}"`,
    );
  }

  return slugifyText;
}
